Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-ajax-buttons', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.js-product-details-ajax-buttons', $context),
            control = $control.get(0);

        if ($control.length < 1)
            return;

        control.loading = function (isLoading) {
            if (isLoading) {
                $control.addClass('x-loading');
            } else {
                $control.removeClass('x-loading');
            }
        };

        $control.on('click', '.js-add-to-order', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled'))
                return;

            control.loading(true);

            $this.addClass('disabled');

            // Collect showroom information
            var showroomId = 0, showroomName = "";            
            var showroomSelector = $('.x-product-details-version-selector select.dim-0-select');         
            if (showroomSelector.length > 0) {
                showroomName = showroomSelector.find('option:selected').text().trim();
                showroomId = parseInt(showroomSelector.find('option:selected').data('id'));             
            }
            
            // Collect product attributes
            var attributes = [];
            var $attributesList = $('#productAttributes .attributes-list');
            if ($attributesList.length > 0) {
                $attributesList.find('li').each(function (index, attribute) {
                    attributes.push({
                        Code: $(attribute).data('code'),
                        Name: $(attribute).data('name'),
                        Value: $(attribute).data('value')
                    });
                });
            }

            // Collect addons
            var addOns = [];
            var $addOns = $('.x-product-details-add-ons', $context);         
            if ($addOns.length > 0) {              
                var $selectedAddOns = $addOns.find(':checked') || $addOns.find(':selected').not("val");
                $.each($selectedAddOns, function (i, addOn) {
                    $addOn = $(addOn);

                    var data = {
                        id: $addOn.data('parent-id'),
                        skuId: $addOn.data('sku-id'),
                        Name: $addOn.data('name'),
                        Price: $addOn.data('price'),
                        Image: $addOn.data('img')
                    };

                    addOns.push(data);
                });
            }
            
            // Data to send
            var data = {
                ParentId: $context.data('parent-id'),
                SelectedId: $context.data('selected-id'),
                VehicleId: $context.data('vehicle-id'),
                ModelId: $context.data('model-id'),
                ModelVariantId: $context.data('model-variant-id'),
                ExteriorColorId: $context.data('exterior-color-id'),
                InteriorColorId: $context.data('interior-color-id'),
                ShowroomId: showroomId,
                ShowroomName: showroomName,
                SalesDescription: $context.data('sales-desc'),
                ModelVariant: $context.data('name'),
                ThumbUrl: $context.data('thumb-url'),
                ImageUrl: $context.data('image-url'),
                Brand: $context.data('brand'),
                Model: $context.data('model'),
                Price: $context.data('price'),
                TotalPrice: $context.data('total-price'),
                Attributes: JSON.stringify(attributes),
                AddOns: JSON.stringify(addOns)
            };

            // Send data to the back-end proxy, which forwards it to the third-party service
            $.ajax({
                type: 'POST',
                url: '/vendd/webapi/cstmJetour/StartFlow',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function (response) {
                    if (response && response.success && response.redirectUrl)
                        window.location.href = response.redirectUrl;

                    $this.removeClass('disabled');

                    control.loading(false);
                },
                error: function () {
                    $this.removeClass('disabled');

                    control.loading(false);
                }
            });
        });

        $control.on('click', '.js-add-to-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).closest('.compare-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId,
                skuId = state.selectedId;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.ProductCompare.Messages.Add(id, skuId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                vendd.MessageBus.publishAsync($control.get(0), new vendd.Widget.Messages.OpenWidget(vendd.Widget.ProductCompareWidget, false));
            }
        });

        $control.on('click', '.js-remove-from-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $product, compareItemtId;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.ProductCompare.Messages.Remove(id));
        });

        $control.on('click', '.js-request-info', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var isUsed = $context.data('is-used').toLowerCase() === 'true';

            var itemId = $context.data('parent-id');
            var modelId = isUsed ? $context.data('vehicle-id') : $context.data('model-id');
            var modelName = $context.data('name');

            $('#request-info-form').attr('data-item-id', itemId);
            $('#request-info-form').attr('data-model-id', modelId);
            $('#request-info-form').attr('data-model-name', modelName);
            $('#request-info-form').attr('data-is-used', isUsed);

            $.fancybox.open({
                src: '#request-info-form',
                type: 'inline',
                touch: false,
                autoFocus: false,
                afterClose: function (instance, current) {
                    //re-initialize form
                    $('#request-info-form').get(0).initialize();
                }
            });
        });
    });

});

